define([
	"dojo/_base/declare",
	"csi/heading/BooleanController",
	"csi/prefs",
	"csi/service/sessionService",
	"csi/sessionConstants",
	"csi/xml",
], function(declare, BooleanController, csiPrefs, { initializeRoles }, sessionConstants, xml) {

	// Controller for Roles management Preferences Check-box

	return declare(BooleanController, {
		/**
		 * @override
		 * Customize the confirm message depending on whether or not the role is being played
		 */
		confirmAction(params) {
			if (this.isRolePlayed()) {
				params.message = this.getString("_ConfirmPlayed");
			}

			// show progress because many custom views could be changed or deleted
			this.bShowProgress = true;
			this.inherited(arguments);
		},

		/**
		 * Indicate if role is being played
		 */
		isRolePlayed() {
			return this.m_urlNode === sessionConstants.roleUrl;
		},

		/**
		 * Indicate if confirmation is required
		 */
		hasToConfirmAction() {
			return this.getNode().ManagePreferences;
		},

		/**
		 * Change or delete custom views that reference this role
		 */
		toWriter() {
			const {bShowProgress, m_urlNode, m_writer} = this;
			const {ATTR_UMENTRY, TYPE_VIEW} = csiPrefs;

			if (bShowProgress) {
				let q = m_writer.createQuery()
					.Type(TYPE_VIEW)
					.RefAttr(ATTR_UMENTRY, xml.OP_EQUALS, m_urlNode)
					.Attr2(ATTR_UMENTRY, xml.OP_EQUALS, {Dimension: 1});

				// force deletion even if used, which could be by personal views based on a shared role view, or
				// custom views referenced by CamundaTaskDefinition
				m_writer.deleteQuery(q, null, null, true);

				q = m_writer.createQuery()
					.Type(TYPE_VIEW)
					.RefAttr(ATTR_UMENTRY, xml.OP_EQUALS, m_urlNode)
					.Attr2(ATTR_UMENTRY, xml.OP_NOT_EQUALS, {Dimension: 1});

				m_writer.changeQuery(q).changeAttribute(ATTR_UMENTRY, xml.ATTR_REFLIST, [m_urlNode], false, true);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * React accordingly if confirmed
		 */
		postProcess(bStatus) {
			if (bStatus) {
				if (this.bShowProgress) {
					// reload page if role being played is no longer playable
					if (this.isRolePlayed()) {
						location.reload();
						return;
					}

					// otherwise, reset custom view stores as custom views may have changed
					csiPrefs.resetStores();
				}

				// refresh roles that can be played
				initializeRoles();
			}

			return this.inherited(arguments);
		}
	});
});